import script from "./BaseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInfo.vue?vue&type=script&setup=true&lang=js"

import "./BaseInfo.vue?vue&type=style&index=0&id=d8c22dbc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c22dbc"]])

export default __exports__